import { Availability } from '../../lib/types/models/availability/availability'
import { AvailabilityInput } from '../../lib/types/models/availability/availability-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function addStaffAvailability(input: IdInput<AvailabilityInput>) {
  const { id, ...data } = input
  return restApiClient
    .url(constructApiUrl(API.staffs.addAvailability.url, { id }))
    .post<Availability, AvailabilityInput>(data)
}
